<template>
    <div>
        <div class="main-content" id="panel">
            <header-component></header-component>
            <!-- Header -->
            <div class="header pb-5 bg-gradient-gray-dark">
                <div class="container">
                    <div class="header-body">
                        <div class="row py-5">
                            <!--nombre del curso-->
                            <div class="col-1">
                                <img src="assets/img/docente/grupos-01.svg" class="pl-8">
                            </div>
                            <div class="col-9 text-center text-white">
                                <h1 class="text-white">Administración de grupos</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page content -->
            <div class="container-fluid mt--6">
                <div class="card col-10 mx-auto">
                    <!-- Card body -->
                    <div class="card-body">
                        <div class="nav-wrapper">
                            <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-1-tab" data-toggle="tab" href="#tabs-icons-text-1" role="tab" aria-controls="tabs-icons-text-1" aria-selected="true">Información general</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-2-tab" data-toggle="tab" href="#tabs-icons-text-2" role="tab" aria-controls="tabs-icons-text-2" aria-selected="false">Estudiantes del grupo</a>
                                </li>
                            
                            </ul>
                        </div>
                        <div class="card shadow">
                            <div class="card-body">
                                <div class="tab-content" id="myTabContent">
                                    <vue-form :state="formstate" @submit.prevent="create()">
                                        <div class="tab-pane fade show active" id="tabs-icons-text-1" role="tabpanel" aria-labelledby="tabs-icons-text-1-tab">
                                            <p class="description">Por favor introduzca la siguiente información para grear su grupo personalizado.</p><br>
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="form-control-label" for="example2cols1Input">Clave del grupo:</label>
                                                        <input type="text" class="form-control" id="example2cols1Input" placeholder="Se generará automáticamente" readonly>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <validate tag="div">
                                                            <label class="form-control-label" for="sGroupName">Nombre de grupo:*</label>
                                                            <input type="text" class="form-control" id="sGroupName" name="sGroupName" v-model="model.sGroupName" placeholder=" " required>
                                                            <field-messages name="sGroupName" show="$invalid && $submitted" class="text-danger">
                                                                <div slot="required">El nombre es requerido</div>
                                                            </field-messages>
                                                        </validate>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <validate tag="div">
                                                            <label class="form-control-label" for="idEduLevel">Nivel educativo:</label>
                                                            <b-form-select v-model="model.idEduLevel" :options="educationLevel" id="idEduLevel" name="idEduLevel" value-field="id" text-field="sOption" required @change="getGrades"></b-form-select>
                                                            <field-messages name="idEduLevel" show="$invalid && $submitted" class="text-danger">
                                                                <div slot="required">El nivel es requerido</div>
                                                            </field-messages>
                                                        </validate>
                                                    </div>
                                                </div>
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <validate tag="div">
                                                            <label class="form-control-label" for="grade">Grado:</label>
                                                            <b-form-select v-model="model.idGrade" :options="grades" id="idGrade" name="idGrade" value-field="id" text-field="sOption" required></b-form-select>
                                                            <field-messages name="idGrade" show="$invalid && $submitted" class="text-danger">
                                                                <div slot="required">El grado es requerido</div>
                                                            </field-messages>
                                                        </validate>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="model.idGrade != ''">
                                                <div class="col-sm-8">
                                                    <div class="form-group">
                                                        <validate tag="div">
                                                            <label class="form-control-label" for="idLicense">Licencias disponibles de <span><strong>Nombre de usuario</strong></span>:</label>
                                                            <b-form-select v-model="model.idLicense" :options="licenses" id="idLicense" name="idLicense" value-field="idLicense" text-field="license" required @change="getCoursesLicense"></b-form-select>
                                                            <field-messages name="idLicense" show="$invalid && $submitted" class="text-danger">
                                                                <div slot="required">La licencia es requerida</div>
                                                            </field-messages>
                                                        </validate>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="model.idGrade != ''">
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <validate tag="div">
                                                            <label for="sStartDate" class="form-control-label">Fecha de inicio*:</label>
                                                            <flat-pickr class="form-control" v-model="model.sStartDate" id="sStartDate" name="sStartDate" required></flat-pickr>
                                                            <field-messages name="sStartDate" show="$invalid && $submitted" class="text-danger">
                                                                <div slot="required">La fecha de inicio es requerida</div>
                                                            </field-messages>
                                                        </validate>
                                                    </div>
                                                </div>
                                            
                                                <div class="col-sm-4">
                                                    <div class="form-group">
                                                        <validate tag="div">
                                                            <label for="sFinalDate" class="form-control-label">Fecha de finalización*:</label>
                                                            <flat-pickr class="form-control" v-model="model.sFinalDate" id="sFinalDate" name="sFinalDate" required></flat-pickr>
                                                            <field-messages name="sFinalDate" show="$invalid && $submitted" class="text-danger">
                                                                <div slot="required">La fecha de finalización es requerida</div>
                                                            </field-messages>
                                                        </validate>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="model.idGrade != ''">
                                                <div class="col-sm-8">
                                                    <div class="form-group">
                                                            <label class="form-control-label" for="sDescription">Descripción:</label>
                                                            <textarea class="form-control" id="sDescription" name="sDescription" v-model="model.sDescription" rows="3"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <div class="form-group custom-control custom-checkbox">
                                                        <input class="custom-control-input" id="customCheck1" type="checkbox">
                                                        <label class="custom-control-label" for="customCheck1">Grupo activo</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <p>Haga clic en los siguientes módulos para incluir en el grupo los cursos de su interés.</p>
                                            <div class="row">
                                                <div class="col-sm-8">
                                                    <table class="table align-items-center table-flush">
                                                        <thead class="thead-light">
                                                            <tr>
                                                                <th>Curso</th>
                                                                <th>Producto</th>
                                                                <th>Certifica</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="course in courses" :key="course.iNumber">
                                                                <td>
                                                                        <input type="checkbox" :id="'check' + course.iNumber" @click="enableCombo(course.iNumber)"> 
                                                                        <label :for="'check' + course.iNumber">{{ course.sCourse }}</label>
                                                                </td>
                                                                <td>
                                                                    <b-form-select :options="course.courses" :id="'version' + course.iNumber" :name="'version' + course.iNumber" value-field="idVersion" text-field="sVersion" disabled @change="setVersion(course.iNumber)"></b-form-select>
                                                                </td>
                                                                <td>
                                                                    Si
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="row float-right">
                                                <button type="submit" class="btn btn-secondary"><i class="fa fa-save"></i> Guardar</button> <router-link to="/admin-groups" class="btn btn-dark"><i class="fa fa-times-circle"></i> Cancelar</router-link>
                                            </div>
                                        </div>
                                    </vue-form>
                                    <div class="tab-pane fade" id="tabs-icons-text-2" role="tabpanel" aria-labelledby="tabs-icons-text-2-tab">
                                        <p class="description">Lorem ipsum</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NavigationComponent from '@/components/NavigationComponent'
import HeaderComponent from '@/components/HeaderComponent'
import VueForm from "vue-form"
import options from "../validations/validations.js";
Vue.use(VueForm, options);
export default {
    name: 'GroupInfo',
    components: {
        NavigationComponent, HeaderComponent, flatPickr
    },
    data() {
        return {
            usuario: {},
            formstate: {},
            hostname: '',
            educationLevel: [],
            grades: [],
            licenses: [],
            courses: [],
            model: {
                idEduLevel: '',
                idGrade: '',
                idLicense: '',
                VersionApss: [],
                sDescription: '',
            }
        }
    },
    methods: {
        async getEducationLevel() {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/educationLevel', { headers: clientAPI })
            .then( (response) => {
                this.educationLevel = response.data.options
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getGrades(value) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/grades?idEduLevel=' + value, { headers: clientAPI })
            .then( (response) => {
                Swal.close()
                this.grades = response.data.options
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getLicences() {
            await axios.get(apiKS + 'api/rpt-ethinking/json/licenses', { headers })
            .then( (response) => {
                Swal.close()
                this.licenses = response.data.listLicenses
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getCoursesLicense(value) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/coursesLicense?idEduLevel=' + this.model.idEduLevel + '&idLicense=' + this.model.idLicense + '&idGrade=' + this.model.idGrade, { headers })
            .then( (response) => {
                Swal.close()
                this.courses = response.data
            })
            .catch( error => {
                this.catchError(error)
            })
        },

        enableCombo(version) {
            if($('#check' + version).is(':checked')){
                $('#version' + version).prop('disabled', false)
                if($('#version' + version).val() > 0)
                    this.model.VersionApss.push({ idApp: $('#version' + version).val() })
            }
            else {
                $('#version' + version).prop('disabled', true)
                if($('#version' + version).val() > 0) {
                    let index = this.model.VersionApss.findIndex( element => element.idApp == $('#version' + version).val() )

                    this.model.VersionApss.splice(index, 1)
                }
            }
        },
        async create() {
            if (this.formstate.$invalid) {
                return;
            } else {
                await this.saveDataNoForm('api/ethinking/create-group', this.model, '', '', null, 0, 1, null)
            }
        },
        setVersion(version) {
            if($('#version' + version).val() > 0)
                this.model.VersionApss.push({ idApp: $('#version' + version).val() })
        }
    },
    async mounted() {
        this.hostname = hostname
        if(!user) {
            await this.getUserApi()
            this.usuario = user
        } else {
            this.usuario = user
        }

        await this.getEducationLevel()
        await this.getLicences()
    },
    beforeMount() {
        document.body.classList.remove('bg-mos1')
    },
    watch: {
        
    }
}
</script>